import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Component3cards from '../components/component3cards'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './astorino.css'

const Astorino = (props) => {
  return (
    <div className="astorino-container">
      <Helmet>
        <title>Учебный робот Astorino | Обучение робототехнике | Arcobo</title>
        <meta
          name="description"
          content="Arcobo поставляет учебных роботов Kawasaki Astorino для изучения промышленной робототехники. Идеальное решение для вузов, колледжей и учебных лабораторий."
        />
        <meta
          property="og:title"
          content="Учебный робот Astorino | Обучение робототехнике | Arcobo"
        />
        <meta
          property="og:description"
          content="Arcobo поставляет учебных роботов Kawasaki Astorino для изучения промышленной робототехники. Идеальное решение для вузов, колледжей и учебных лабораторий."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Учебный робот Astorino | Обучение робототехнике | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Arcobo поставляет учебных роботов Kawasaki Astorino для изучения промышленной робототехники. Идеальное решение для вузов, колледжей и учебных лабораторий."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/astorino"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/astorino"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Astorino","item":"https://arcobo.tech/astorino"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name17"></HeaderMain>
      <hr className="astorino-separator1"></hr>
      <Componenttextimage
        image1Src="/1_Solution/1_3_2_Astorino/astorino_00-1500w.webp"
        image1Alt="Учебный робототехнический комплекс Astorino"
        rootClassName="componenttextimageroot-class-name5"
        textComponent={
          <Fragment>
            <span className="astorino-text100">
              <span className="H1_extrasmall">
                Учебный робот, разработанный специально для школ, колледжей,
                вузов и корпоративных учебных центров
              </span>
              <br className="astorino-text102"></br>
              <span>
                Astorino сочетает безопасность с логикой промышленного робота.
                Программы, разработанные на Astorino, могут быть перенесены на
                промышленные роботы Kawasaki Robotics, что делает обучение
                максимально приближенным к реальному производству.
              </span>
              <br></br>
              <br></br>
              <span className="H1_small">Преимущества и выгоды:</span>
              <br className="astorino-text107"></br>
              <span className="astorino-text108">✔ </span>
              <span className="H1_extrasmall">
                Подготовка к работе с промышленными роботами Kawasaki
              </span>
              <br></br>
              <span>
                Программирование выполняется в среде, максимально приближенной к
                промышленным роботам Kawasaki, что значительно сокращает время
                адаптации выпускников на производстве.
              </span>
              <br></br>
              <span className="astorino-text113">✔ </span>
              <span className="H1_extrasmall">
                Полный комплект учебной документации
              </span>
              <br></br>
              <span>
                Руководства, методические материалы, лабораторные работы и
                инструкции позволяют быстро внедрить робототехнический курс.
              </span>
              <br></br>
              <span className="astorino-text118">✔ </span>
              <span className="H1_extrasmall">
                Простой ремонт и модернизация
              </span>
              <br></br>
              <span>
                Большинство пластиковых элементов корпуса могут быть изготовлены
                на обычном 3D-принтере, что упрощает обслуживание и позволяет
                создавать собственные модификации.
              </span>
              <br></br>
              <span className="astorino-text123">✔ </span>
              <span className="H1_extrasmall">
                Большая библиотека учебных материалов
              </span>
              <br></br>
              <span>
                Видеоуроки, примеры программ, готовые лабораторные работы и
                практические задания ускоряют освоение робототехники.
              </span>
              <br></br>
              <span className="astorino-text128">✔ </span>
              <span className="H1_extrasmall">
                Открытая платформа для экспериментов
              </span>
              <br></br>
              <span>
                Astorino поддерживает подключение камер, захватов, конвейеров,
                дополнительных осей и другого периферийного оборудования.
              </span>
              <br></br>
              <span className="astorino-text133">✔ </span>
              <span className="H1_extrasmall">
                Минимальные эксплуатационные расходы
              </span>
              <br></br>
              <span>
                Конструкция робота рассчитана на длительное использование в
                учебном процессе без дорогостоящего обслуживания.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Astorino"
      ></Componenttextimage>
      <Component3images
        image1Src="/1_Solution/1_3_2_Astorino/astorino_21-200h.webp"
        image1Alt="Комплектации Astorino"
        image2Src="/1_Solution/1_3_2_Astorino/astorino_22-200h.webp"
        image2Alt="Комплектации Astorino"
        image3Src="/1_Solution/1_3_2_Astorino/astorino_23-200h.webp"
        image3Alt="Комплектации Astorino"
        rootClassName="component3imagesroot-class-name"
      ></Component3images>
      <hr className="astorino-separator2"></hr>
      <Component3cards
        showBigTitle={false}
        componentText="Единая программная среда, единая логика обучения и возможность масштабирования лаборатории по мере роста компетенций."
        feature1Title="Robot Astorino Basic"
        feature2Title="Astorino Station ECO"
        feature3Title="Astorino Station PRO"
        rootClassName="component3cardsroot-class-name1"
        componentTitle="Три комплектации Astorino"
        feature1Title2={
          <Fragment>
            <span className="astorino-text137">feature1Title</span>
          </Fragment>
        }
        feature2Title2={
          <Fragment>
            <span className="astorino-text138">Astorino Station ECO</span>
          </Fragment>
        }
        feature3Title2={
          <Fragment>
            <span className="astorino-text139">Astorino Station PRO</span>
          </Fragment>
        }
        feature1ImageSrc="/1_Solution/1_3_2_Astorino/astorino_01-1500w.webp"
        feature1ImageAlt="Комплектация Astorino"
        feature2ImageSrc="/1_Solution/1_3_2_Astorino/astorino_02-400h.webp"
        feature2ImageAlt="Комплектация Astorino"
        feature3ImageSrc="/1_Solution/1_3_2_Astorino/astorino_03-400h.webp"
        feature3ImageAlt="Комплектация Astorino"
        feature1Description={
          <Fragment>
            <span className="astorino-text140">
              <span className="astorino-text141">В комплект входят:</span>
              <br></br>
              <span>1. Базовый робот</span>
              <br></br>
              <span>2. Встроенная система управления</span>
              <br></br>
              <span>3. Программное обеспечение и прошивка на флешке</span>
              <br></br>
              <span>4. Детектор столкновений</span>
              <br></br>
              <span>5. CAD-файл робота</span>
              <br></br>
              <span>6. Руководство пользователя</span>
              <br></br>
              <span>7. Руководство по безопасности</span>
              <br></br>
              <span>8. Внешняя кнопка аварийного останова 24 В</span>
              <br></br>
              <span>9. Связь USB/Ethernet</span>
              <br></br>
              <span>10. Связь Modbus TCP</span>
              <br></br>
              <span>11. Модуль 8 I/O 3,3 В, источник питания 24 В</span>
            </span>
          </Fragment>
        }
        feature2Description="В комплект входят: 1.\xA0Robot Astorino Basic 2. Платформа с аксессуарами 3. Компрессор с блоком питания 4.\xA0пневматический захват"
        feature3Description="1. Robot Astorino Basic 2. Монтажная плата с выделенным рабочим столом 3. Компрессор с блоком питания 4. Пневматический захват 5. Оборудование и программа подачи кубов 6. Система технического зрения, на Python 7. Кнопки для самостоятельного программирования"
        feature2Description1={
          <Fragment>
            <span className="astorino-text164">
              <span className="astorino-text165">В комплект входят</span>
              <span className="astorino-text166">:</span>
              <br></br>
              <span>1. Robot Astorino Basic</span>
              <br></br>
              <span>2. Платформа с аксессуарами</span>
              <br></br>
              <span>3. Компрессор с блоком питания</span>
              <br></br>
              <span>4. пневматический захват</span>
            </span>
          </Fragment>
        }
        feature3Description1={
          <Fragment>
            <span className="astorino-text175">
              <span className="astorino-text176">В комплект входят:</span>
              <br></br>
              <span>
                1. Robot Astorino Basic
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                2. Монтажная плата с выделенным рабочим столом
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                3. Компрессор с блоком питания
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                4. Пневматический захват
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                5. Оборудование и программа подачи кубов
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                6. Система технического зрения, на Python
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>7. Кнопки для самостоятельного программирования</span>
            </span>
          </Fragment>
        }
      ></Component3cards>
      <Component3images
        image1Src="/1_Solution/1_3_2_Astorino/astorino_31-200h.webp"
        image1Alt="Учебный комплекс Astorino"
        image2Src="/1_Solution/1_3_2_Astorino/astorino_32-200h.webp"
        image2Alt="Учебный комплекс Astorino"
        image3Src="/1_Solution/1_3_2_Astorino/astorino_33-200h.webp"
        image3Alt="Учебный комплекс Astorino"
        rootClassName="component3imagesroot-class-name1"
      ></Component3images>
      <hr className="astorino-separator3"></hr>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="astorino-text191">
              <span>
                Astorino специально разработан для обучения, сохраняя принципы
                программирования и кинематику промышленного робота. Благодаря
                этому студенты изучают реальные подходы к промышленной
                робототехнике в безопасной учебной среде, а полученные навыки
                легко переносятся на промышленные роботы Kawasaki Robotics.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="astorino-text194">
              <span>
                Astorino предназначен для школ, колледжей, университетов,
                центров дополнительного образования и корпоративных учебных
                центров. Комплекс одинаково хорошо подходит как для первых шагов
                в робототехнике, так и для подготовки инженеров по автоматизации
                и промышленной роботизации.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="astorino-text197">
              <span>
                Astorino позволяет проводить занятия по промышленной
                робототехнике, программированию роботов, автоматизации
                производства, мехатронике, машинному зрению, управлению
                приводами и цифровому производству. Благодаря открытой
                архитектуре комплекс также подходит для выполнения лабораторных
                работ, дипломных проектов и научных исследований.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="astorino-text200">
              <span>
                Большинство учебных роботов обучают работе с конкретным учебным
                устройством, тогда как Astorino готовит студентов к работе с
                промышленными роботами. Реалистичная кинематика,
                профессиональная среда программирования, возможность
                модернизации и перенос полученных навыков на реальные
                производственные комплексы делают обучение максимально
                практичным.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="astorino-text203">
              <span>
                Да.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                Astorino идеально подходит для инженерных соревнований,
                хакатонов и проектного обучения благодаря открытой архитектуре и
                широким возможностям модернизации. Студенты могут разрабатывать
                собственные алгоритмы управления, интегрировать машинное зрение,
                дополнительные оси, захваты и другое периферийное оборудование,
                создавая проекты различной сложности.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="astorino-text208">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="astorino-text209">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="astorino-text210">answer</span>
          </Fragment>
        }
        showDiv5
        showDiv6
        showDiv7
        question1="Чем Astorino отличается от промышленного робота?"
        question2="Для каких образовательных учреждений подходит Astorino?"
        question3="Какие дисциплины можно преподавать с помощью Astorino?"
        question4="Почему Astorino лучше обычных учебных манипуляторов?"
        question5="Можно ли использовать Astorino для соревнований, хакатонов и проектной деятельности?"
        rootClassName="componentfaqroot-class-name"
      ></Componentfaq>
      <hr className="astorino-separator4"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name17"></FooterMain>
    </div>
  )
}

export default Astorino
